import styled from "styled-components";

export const SolutionInfoWrapper = styled.div`
  padding: 1.375rem;
  max-height: 60vh;
  overflow-y: auto;
`;

export const SolutionInfoWrapperSpacing = styled.div`
  margin-bottom: 1.375rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SolutionInfoText = styled.div`
  font-family: Lato;
  font-size: 16px;
  display: flex;
  align-items: center;
`;

export const SolutionTitleText = styled.h2`
  color: #ed6b08;
  font-size: 16px;
  font-family: lato;
  text-transform: initial;
  margin: 0;
  line-height: 1;
`;

export const SolutionTitleValue = styled.p`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
`;
